// src/services/userService.js
import api from './api';

const userService = {
  // Get all users by role
  getUsersByRole: async (role, page = 1, limit = 20,search = '') => {
    console.log("🚀 ~ role:", role)
    try {
      const response = await api.get(`/admin/users`, {
        params: { role, page, limit, search }
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${role}s:`, error);
      throw error;
    }
  },

  // Create new user
  createUser: async (userData) => {
    try {
      const response = await api.post('/admin/users/create', userData);
      return response.data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  },

  // Update user
  updateUser: async (userId, userData) => {
    try {
      const response = await api.put(`/admin/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  },

  // Change user password
  changePassword: async (userId, newPassword) => {
    try {
      const response = await api.post(`/admin/users/${userId}/change-password`, { newPassword });
      return response.data;
    } catch (error) {
      console.error('Error changing password:', error);
      throw error;
    }
  },

  // Toggle user status
  toggleStatus: async (userId) => {
    try {
      const response = await api.put(`/admin/users/${userId}/toggle-status`);
      return response.data;
    } catch (error) {
      console.error('Error toggling status:', error);
      throw error;
    }
  },

  // Delete user
  deleteUser: async (userId) => {
    try {
      const response = await api.delete(`/admin/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  },

  // Get user details
  getUserDetails: async (userId) => {
    try {
      const response = await api.get(`/admin/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user details:', error);
      throw error;
    }
  },

   // Update commission rate (NEW)
  updateCommission: async (userId, commissionRate, reason) => {
    const response = await api.put(`/admin/users/${userId}/commission`, {
      commissionRate,
      reason
    });
    return response.data;
  },
  
  // Get commission history for a user (NEW)
  getCommissionHistory: async (userId) => {
    const response = await api.get(`/admin/users/${userId}/commission-history`);
    return response.data;
  },
};

export default userService;